import React from 'react';
import {Router, IndexLink, Link, withRouter} from 'react-router';

var $ = require('jquery');

class Splash_Signin extends React.Component {
    constructor(props) {
        super(props);
        //this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.state = {
            user: {email: '', pass: '', remember: false, disabled: false}
        };
    }

    handleChange(propertyName, event) {
        const user = this.state.user;
        if (propertyName != "remember")
            user[propertyName] = event.target.value;
        else
            user[propertyName] = !user[propertyName];
        this.setState({user: user});
    };

    handleSubmit(event) {
        event.preventDefault();
        const user = this.state.user;
        user['api'] = 'login';
        const email = this.state.user.email.trim();
        const pass = this.state.user.pass.trim();
        if (!email || !pass) {
            if (this.props.type == 0) {
                this.props.router.push('/signin');
            }
            return;
        }
        if (this.state.user.disabled) {
            return;
        }
        this.state.user.disabled = true;
        $.ajax({
            url: this.props.url,
            dataType: 'json',
            type: 'POST',
            data: user,
            success: function (data) {
                console.log(data);
                if (data.status == 1) {
                    if (data.isEmployer == 1) {
                        window.location = "/home";
                    }
                    else if (data.isEmployer == 2) {
                        window.location = "/faculty";
                    }
                    else if (data.isEmployer == 3) {
                        window.location = "/educator";
                    }
                    else if (data.isEmployer == 4) {
                        window.location = "/bridge";
                    }
                    else {
                        window.location = "/career-launcher";
                    }
                    this.setState({user: {email: '', pass: '', remember: false, disabled: false}});
                }
                else {
                    if (this.props.type == 0) {
                        this.props.router.push('/signin');
                    }
                    this.props.openDialog(data.message);

                    //console.log('alert here');
                }
                this.state.user.disabled = false;

            }.bind(this),
            error: function (xhr, status, err) {
                console.error(this.props.url, status, err.toString());
                this.state.user.disabled = false;
            }.bind(this)
        });
        //user[propertyName] = event.target.value;
    };

    render() {
        if (this.props.type == 0) {
			if (this.props.isMobile == 1) {
                return (
                    <form onSubmit={this.handleSubmit}>
                        <div className="account_box_wrappers">
                            <div className={"head"}>
                                <div className={"content"}>
                                    <h3>Welcome to Versity</h3>
                                    <small>Your University Network</small>

                                    <input
                                        type="email"
                                        className={"form-control input-lg"}
                                        onChange={this.handleChange.bind(this, 'email')}
                                        value={this.state.user.email}
                                        placeholder="Email"
                                        name="lemail"/>
                                </div>
                            </div>
                            <div className={"bottom"}>
                                <div className={"content"}>
                                    <input
                                        type="password"
                                        className={"form-control input-lg"}
                                        onChange={this.handleChange.bind(this, 'pass')}
                                        value={this.state.user.pass}
                                        placeholder="Password"
                                        name="lpass"/>
                                    <p>&nbsp;</p>
                                    <input
                                        type="submit"
                                        className={"btn btn-lg btn-primary btn-block"}
                                        name="flogin"
                                        disabled={this.state.user.disabled}
                                        value="Sign In"/>
                                    <p><Link className={"btn03"} to="/forgot">Forgot password?</Link></p>
                                    <p>Not on Versity? <Link className={"btn04"} to="/signup">Join now</Link></p>
                                </div>
                            </div>
                        </div>
                    </form>
                )
            }
            return (
                <form onSubmit={this.handleSubmit}>
                    <ul className="splash_head_login">
                        <li>
                            <input type="email" onChange={this.handleChange.bind(this, 'email')}
                                   value={this.state.user.email} tabIndex="1" placeholder="Email" name="lemail"/>
                        </li>
                        <li>
                            <input type="password" onChange={this.handleChange.bind(this, 'pass')}
                                   value={this.state.user.pass} tabIndex="2" placeholder="Password" name="lpass"/>
                        </li>
                        <li>
                            <input type="submit" value="Sign In" disabled={this.state.user.disabled}/>
                            <span className="note">
                        <Link to="/forgot">Forgot Password?</Link>
                    </span>
                        </li>
                    </ul>
                </form>
            )
        }
        else {
            if (this.props.isMobile == 1) {
                return (
                    <form onSubmit={this.handleSubmit}>
                        <div className="account_box_wrappers">
                            <div className={"head"}>
                                <div className={"content"}>
                                    <h3>Welcome back to Versity</h3>
                                    <small>Let’s get inspired today</small>

                                    <input
                                        type="email"
                                        className={"form-control input-lg"}
                                        onChange={this.handleChange.bind(this, 'email')}
                                        value={this.state.user.email}
                                        placeholder="Email"
                                        name="lemail"/>
                                </div>
                            </div>
                            <div className={"bottom"}>
                                <div className={"content"}>
                                    <input
                                        type="password"
                                        className={"form-control input-lg"}
                                        onChange={this.handleChange.bind(this, 'pass')}
                                        value={this.state.user.pass}
                                        placeholder="Password"
                                        name="lpass"/>
                                    <p>&nbsp;</p>
                                    <input
                                        type="submit"
                                        className={"btn btn-lg btn-primary btn-block"}
                                        name="flogin"
                                        disabled={this.state.user.disabled}
                                        value="Sign In"/>
                                    <p><Link className={"btn03"} to="/forgot">Forgot password?</Link></p>
                                    <p>Not on Versity? <Link className={"btn04"} to="/business/signup">Join now</Link></p>
                                </div>
                            </div>
                        </div>
                    </form>
                )
            }
            return (
                <form onSubmit={this.handleSubmit} className="class-form-signin">
                    <div className="account_box_wrappers pc-signup">
                        <h2>Log into Versity</h2>
                        <p className="input01">
                            <input
                                type="email"
                                onChange={this.handleChange.bind(this, 'email')}
                                value={this.state.user.email}
                                placeholder="Email"
                                name="lemail"/>
                        </p>
                        <p className="input01">
                            <input
                                type="password"
                                onChange={this.handleChange.bind(this, 'pass')}
                                value={this.state.user.pass}
                                placeholder="Password"
                                name="lpass"/>
                        </p>
                        <p className="btn01">
                            <input
                                type="submit"
                                name="flogin"
                                disabled={this.state.user.disabled}
                                value="SIGN IN"/>
                        </p>
                        <Link className={"btn03"} to="/forgot">Recover Your Account</Link>
                        <Link className={"btn04"} to="/business/signup">Sign up for Versity</Link>
                    </div>
                </form>
            )
        }
    }
};
Splash_Signin.propTypes = {
    router: React.PropTypes.shape({
        push: React.PropTypes.func.isRequired
    }).isRequired
};

export default withRouter(Splash_Signin);



/** WEBPACK FOOTER **
 ** ./src/client/app/homecomponents/commons/splash_signin.js
 **/